import {isValid, toDate} from "date-fns";
import {formatInTimeZone} from "date-fns-tz";

import {timezoneAbbr} from "@/lib/format.tsx";
import {DateFormatDateFns, DateFormatName, TimeFormatDateFns, TimeFormatName} from "@/lib/types/common.ts";

export type RequiredDateRange = {
  from: Date;
  to: Date;
};

export const dateFromURL = (key: string, query: URLSearchParams, defaultValue: Date): Date => {
  const urlValue = query.get(key);
  return urlValue ? new Date(urlValue) : defaultValue;
};

export const fromURL = <T>(key: string, query: URLSearchParams, convert: (v: string) => T, defaultValue: T): T => {
  const urlValue = query.get(key);
  return urlValue ? convert(urlValue) : defaultValue;
};

export const timeStringWithTimezone = (
  date: Date,
  timezone: string = "UTC",
  format: TimeFormatName = TimeFormatName.DEFAULT
): string => {
  if (!isValid(toDate(date))) {
    return "—";
  }
  return `${formatInTimeZone(date, timezone, TimeFormatDateFns[format])} ${timezoneAbbr(timezone)}`;
};

export const dateStringWithTimezone = (
  date: Date,
  timezone: string = "UTC",
  format: DateFormatName = DateFormatName.DEFAULT
): string => {
  if (!isValid(toDate(date))) {
    return "—";
  }
  return `${formatInTimeZone(date, timezone, DateFormatDateFns[format])}`;
};
